import { useState } from 'react';
import { usePWA } from '../context/PWAContext';

const PWAInstallPrompt = () => {
  const { isInstallable, isInstalled, triggerInstall } = usePWA();
  const [dismissed, setDismissed] = useState(false);

  if (!isInstallable || isInstalled || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto
                    md:right-6 md:w-80 bg-white border border-gray-200
                    rounded-xl shadow-lg z-50 p-4 flex items-center gap-3">
      <img
        src="/luxe-looks-logo2.jpg"
        alt="Luxe Looks"
        className="w-12 h-12 rounded-lg object-contain flex-shrink-0"
      />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-gray-900 text-sm">
          Install Luxe Looks
        </p>
        <p className="text-xs text-gray-500 mt-0.5">
          Shop beauty on the go — add to your home screen
        </p>
      </div>
      <div className="flex flex-col gap-1.5 flex-shrink-0">
        <button
          onClick={triggerInstall}
          className="px-3 py-1.5 bg-gold text-white text-xs font-medium
                     rounded-lg hover:bg-yellow-600 transition-colors"
        >
          Install
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="px-3 py-1.5 text-gray-400 text-xs
                     hover:text-gray-600 transition-colors text-center"
        >
          Not now
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
